import { FormLabel } from "@mui/material";
import { styled } from "@mui/material/styles";

const CustomFormLabel = styled(FormLabel)(({ theme }) => ({
  "color": theme.palette.text.primary,
  "fontSize": "14px",
  "fontStyle": "normal",
  "fontWeight": 500,
  "lineHeight": "20px",
  "width": "fit-content",
  "&.Mui-disabled": {
    color: theme.palette.text.disabled,
  },
}));

export default CustomFormLabel;
